import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../store/index.ts";
import { fetchHistoryGames } from "../../store/gamesSlice";

export default function useFillHistories(countGames, setLoader = () => {}) {
  const dispatch = useDispatch();
  const currency = useAppSelector((state) => state.user.currency);

  useEffect(() => {
    if (!currency) return undefined;

    let active = true;
    setLoader(true);

    dispatch(fetchHistoryGames({ countGames, currency }))
      .unwrap()
      .catch((error) => {
        if (error?.name === "ConditionError") return;
        console.error(error);
      })
      .finally(() => {
        if (active) setLoader(false);
      });

    return () => {
      active = false;
    };
  }, [currency, countGames, dispatch]);
}
